import styled from "styled-components";
import { FONTS } from "../../shared";
import { MEDIA_QUERY } from "../../entities/Common";

export const TypographyStyled = styled.div`
  padding: 0;
  margin: 0;
  p {
    margin: 0;
    padding: 0;
  }
  &.type-bold {
    font-weight: ${FONTS.FONT_WEIGHT_BOLD};
  }
  &.title-four {
    font: normal normal normal 25px/13px Arial;
  }
  &.title-five {
    font: normal normal normal 20px/13px Arial;
  }

  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    &.title-four {
      font: normal normal normal 20px/13px Arial;
    }
    &.title-five {
      font: normal normal normal 16px/13px Arial;
    }
    p {
      font-size: 14px;
    }
  }
`;
